import { Button, Result } from 'antd'
import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from 'react-router-dom'

import ErrorLayout from '@Layouts/ErrorLayout'

function ErrorHandler(): JSX.Element {
  const error = useRouteError()
  const navigate = useNavigate()

  if (isRouteErrorResponse(error)) {
    switch (error.status) {
      case 404:
        return (
          <ErrorLayout>
            <Result
              status="warning"
              title={
                <h1 className="font-medium text-3xl text-gray-900 mt-4">404</h1>
              }
              subTitle={<p>Sorry, the page you visited does not exist.</p>}
              extra={
                <Button
                  type="primary"
                  size="large"
                  className={`!px-5 !py-2.5 !leading-none w-44 border bg-primary-600 hover:!bg-primary-700 !border-primary-600 text-white disabled:!bg-primary-300 disabled:!border-primary-300 disabled:text-white`}
                  onClick={() => navigate('/')}
                >
                  Back Home
                </Button>
              }
            />
          </ErrorLayout>
        )
      default:
        break
    }
    return <div>Error</div>
  }

  // return <div>Internal error: {JSON.stringify(error)}</div>
  return <div>Error</div>
}

export default ErrorHandler
